import { useQuery } from "@tanstack/react-query";
import { getBucketFiles } from "@coworker/apprestructured/src/task-management/services/uploads.service";
import { SignedUpload } from "@coworker/apprestructured/src/task-management/types/Upload";

export function useBucketFiles(signedUploads: SignedUpload[]) {
  return useQuery({
    queryKey: ["bucket-files", signedUploads.map(({ bucket_id }) => bucket_id)],
    queryFn: () =>
      getBucketFiles(signedUploads.map(({ signed_url }) => signed_url)),
    staleTime: Infinity,
    enabled: signedUploads.length > 0,
  });
}
